import React from 'react';
import { Search } from 'lucide-react';

const LiveScanLandingPage = ({ user }) => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 py-8 px-4">
            <div className="fixed inset-0 opacity-10 pointer-events-none">
                <div className="absolute top-0 -left-4 w-96 h-96 rounded-full filter blur-3xl"
                    style={{ background: 'linear-gradient(90deg, rgb(20, 184, 166) 0%, rgb(37, 99, 235) 100%)' }}></div>
                <div className="absolute bottom-0 -right-4 w-96 h-96 rounded-full filter blur-3xl"
                    style={{ background: 'linear-gradient(90deg, rgb(20, 184, 166) 0%, rgb(37, 99, 235) 100%)' }}></div>
            </div>

            <div className="max-w-5xl mx-auto relative z-10">
                <div className="mb-10 text-center">
                    <h1 className="text-4xl font-bold text-gray-800 mb-3 flex items-center justify-center gap-3">
                        <Search className="text-teal-600" size={40} />
                        Live Scan
                    </h1>
                    <p className="text-gray-600 text-lg">Choose your scanning method</p>
                </div>

                <div className="flex flex-col gap-6">

                    {/* Universal Live Scan - Hero Card (full width, prominent) */}
                    <div className="bg-white rounded-2xl shadow-xl overflow-hidden border-2 border-teal-400 flex flex-col">
                        <div className="bg-gradient-to-r from-teal-500 to-blue-600 p-6 text-white">
                            <div className="flex items-center gap-3 mb-2">
                                <h2 className="text-2xl font-bold">Universal Live Scan</h2>
                                <span className="bg-white/20 text-white text-xs font-bold px-3 py-1 rounded-full">PRO</span>
                                <span className="bg-amber-600 text-white text-xs font-bold px-3 py-1 rounded-full">⭐ NEW</span>
                            </div>
                            <p className="text-teal-100 text-sm">Scan any website with our Chrome Extension</p>
                        </div>
                        <div className="p-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
                                <div className="rounded-xl overflow-hidden" style={{ aspectRatio: '16/9' }}>
                                    <iframe
                                        width="100%"
                                        height="100%"
                                        src="https://www.youtube.com/embed/rtlDOpvow3s"
                                        title="Universal Live Scan Tutorial"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                                        allowFullScreen
                                        style={{ display: 'block', width: '100%', height: '100%', minHeight: 200 }}
                                    />
                                </div>
                                <div>
                                    <ul className="space-y-3 mb-6">
                                        <li className="flex items-center gap-2 text-sm text-gray-700"><span className="text-teal-500 font-bold">✓</span>Scan any retail website</li>
                                        <li className="flex items-center gap-2 text-sm text-gray-700"><span className="text-teal-500 font-bold">✓</span>Works with Chrome Extension</li>
                                        <li className="flex items-center gap-2 text-sm text-gray-700"><span className="text-teal-500 font-bold">✓</span>Real-time deal discovery</li>
                                        <li className="flex items-center gap-2 text-sm text-gray-700"><span className="text-teal-500 font-bold">✓</span>Faster Results</li>
                                    </ul>
                                    <a href="/universal-live-scan" className="block w-full bg-gradient-to-r from-teal-500 to-blue-600 text-white py-3 rounded-xl font-semibold text-center hover:shadow-lg transition text-base">
                                        Start Universal Scan →
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Live Scan - Demoted, smaller, green-tinted */}
                    <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-teal-400 flex flex-col opacity-70">
                        <div className="bg-gray-50 p-4">
                            <div className="flex items-center gap-2 mb-1">
                                <h2 className="text-lg font-semibold text-teal-700">Live Scan</h2>
                                <span className="bg-teal-100 text-teal-600 text-xs font-semibold px-2 py-0.5 rounded-full">UNLIMITED</span>
                                <span className="bg-amber-600 text-white text-xs font-bold px-3 py-1 rounded-full">OLD</span>
                                <div className="flex-1">
                                    <a href="/live-scan-classic" className="inline-block px-5 py-2 ml-4 rounded-lg border border-teal-300 text-white text-sm font-medium bg-teal-500 hover:bg-teal-600 transition">
                                        Start Live Scan →
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <p className="text-center text-gray-400 text-xs mt-8">
                Not sure which to use?{' '}
                <a
                    href="/webinars"
                    target="_blank"
                    rel="noreferrer"
                    className="text-teal-600 underline font-semibold"
                >
                    Join our weekly webinar
                </a>{' '}
                and we'll walk you through it.
            </p>
        </div>
    );
};

export default LiveScanLandingPage;